module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<form class="page-grid base-form league-form">\n	<div class="form-group one-line code-field">\n		<div class="form-part">\n			<span class="label">League PIN</span>\n			<input type="text" class="base-text-input code js-league-code" name="league_code" value="'+
((__t=( code ))==null?'':_.escape(__t))+
'" disabled>\n		</div>\n\n		<div class="form-part">\n			<a href="javascript:void(0)" class="base-btn tertiary-btn js-copy-league-code">COPY</a>\n		</div>\n\n		<div class="tooltip-bar">\n			<div class="tooltip-text">\n				<h4>League PIN</h4>\n				<p>Share your League PIN with others to allow them to join your league</p>\n			</div>\n			<span class="tooltip-icon">?</span>\n		</div>\n	</div>\n	<div class="copied js-copied-code hidden">Copied!</div>\n\n	<div class="form-group user-emails js-email-fields">\n		<span class="label">Choose who to invite from last year</span>\n		';
 _.each(users, function(user, key){ 
__p+='\n			<div class="form-part js-email-item '+
((__t=( (key > 9) ? 'hidden' : '' ))==null?'':_.escape(__t))+
'">\n				<input type="text" class="user-name js-invite-first-name" value="'+
((__t=( user.firstname ))==null?'':_.escape(__t))+
'"/>\n				<input type="email" class="user-email base-text-input js-invite-by-email"\n					   placeholder="Enter an email address"\n					   value="'+
((__t=( user.email ))==null?'':_.escape(__t))+
'">\n\n				<div class="checkbox-block">\n					<input type="checkbox" id="checkbox_'+
((__t=( key ))==null?'':_.escape(__t))+
'" value="1" checked />\n					<label for="checkbox_'+
((__t=( key ))==null?'':_.escape(__t))+
'" class="ion-checkmark-round"></label>\n				</div>\n			</div>\n		';
 }) 
__p+='\n	</div>\n\n	';
 if(users.length > 10) { 
__p+='\n		<div class="load-more">\n			<a href="javascript:void(0)" class="js-load-more load-more-bt simple-button">\n				View More\n				<i class="ion-chevron-down" ></i>\n			</a>\n		</div>\n	';
 } 
__p+='\n\n	<div class="buttons-wrapper">\n		<a href="/fantasy/league/'+
((__t=( id ))==null?'':_.escape(__t))+
'/regenerate/congratulation" class="base-btn secondary-btn">Skip this step</a>\n		<a href="javascript:void(0)" class="base-btn primary-btn js-send-email-invites">Send Invites</a>\n	</div>\n\n	<input type="submit"/>\n</form>';
}
return __p;
};
